// extracted by mini-css-extract-plugin
export default {"link":"link--n5k1J"};